import useStripeExpressWalletSdk from './useStripeExpressWalletSdk';

/**
 * Express Checkout Element wallet config limited to Google Pay.
 * Other wallets stay disabled so the ECE is the single channel for this method;
 * Apple Pay mounts its own ECE instance with its own config.
 */
const GOOGLE_PAY_PAYMENT_METHODS = {
  googlePay: 'always',
  applePay: 'never',
  link: 'never',
  paypal: 'never',
  amazonPay: 'never',
};

/**
 * useStripeGooglePaySdk hook.
 * Thin wrapper over the shared `useStripeExpressWalletSdk` primitive bound to Google Pay:
 * the ECE is limited to Google Pay, availability is read from the `googlePay` key of the `ready`
 * event, and status/error codes are namespaced with the `google_pay` prefix.
 *
 * @param {object} props - enabled, amount, currency, appearance, locale, onClick, onConfirm, onCancel, onReady.
 * @returns {object} Google Pay ECE state and container ref.
 */
function useStripeGooglePaySdk(props) {
  return useStripeExpressWalletSdk({
    ...props,
    paymentMethods: GOOGLE_PAY_PAYMENT_METHODS,
    walletKey: 'googlePay',
    errorPrefix: 'google_pay',
  });
}

export default useStripeGooglePaySdk;
